export const TESTIMONIALS = [
  {
    name: "Jessica C.",
    role: "JDC Livestock",
    audience: "business",
    stars: 5,
    quote: "Acadia Media and Marketing has been so great to work with! ... a solid social media plan, creating various engagement opportunities for our audience, and putting together a solid networking design. She has been great to us!",
  },
  {
    name: "Crystal L.",
    role: "American Beauty Woodworking",
    audience: "business",
    stars: 5,
    quote: "Aleigh mixes creativity and innovation to create marketing products to take your business to the next level. She overhauled my website, making it more esthetically pleasing and user friendly. ... If you are looking for help with marketing your business and taking it to the next level, Aleigh at Acadia is the one for you!",
  },
  {
    name: "Jackie D.",
    role: "Real estate agent, Keller Williams",
    audience: "agent",
    stars: 5,
    quote: "I run my own business and needed to stand out ... Acadia media and marketing came to the rescue. Aleigh got me setup for success, my social media platforms attracted many people I would not have had in my pipeline. ... If you are looking for help, like serious help with social media you do not want to miss out on this service.",
  },
  {
    name: "Nicole G.",
    role: "Real estate agent, RE/MAX",
    audience: "agent",
    stars: 5,
    quote: "I'm not usually at a loss for creativity, but Aleigh knows exactly how to create and market for me beyond anything I was capable of. It's an immense help and it's getting my name out!",
  },
  {
    name: "Kathleen B.",
    role: "Mortgage professional",
    audience: "business",
    stars: 5,
    quote: "Aleigh is responsive and attentive to detail. Her work is top-notch and extremely professional. I would recommend her to anyone looking to create a website and/or advertise.",
  },
  {
    name: "Dan H.",
    role: "Monell Engine Company, Washingtonville Fire Dept.",
    audience: "community",
    stars: 5,
    quote: "Aleigh did an outstanding job helping the Monell Engine Company and the Washingtonville Fire Department. ... Very responsive, and amazing to work with. We will definitely be using Acadia Media & Marketing in the future.",
  },
];
